<app-organizer-shared-edit-section
  [title]="'organizer.shared.edit_live_url_section.title' | translate"
  [link]="link"
>
  <p>
    {{
      liveUrl || 'organizer.shared.edit_live_url_section.live_url.no_value'
        | translate
    }}
  </p>

  <p *ngIf="noteForAttendees" class="mt-2">
    {{ noteForAttendees }}
  </p>
</app-organizer-shared-edit-section>
